"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var CardRowNumericEditor_1 = require("../../../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var BonusTournamentBotsEditor = /** @class */ (function (_super) {
    __extends(BonusTournamentBotsEditor, _super);
    function BonusTournamentBotsEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentBotsEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_ATG = this.props.listTournamentGamesAvail.Subscribe("*", function (id, data) {
            _this.setState({ atGames: data.data });
        });
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    join_tournament_type_code: _item.join_tournament_type_code,
                    join_tournament_type_title: _item.join_tournament_type_title,
                    usr_player_id: _item.usr_player_id,
                    usr_player_login: _item.usr_player_login,
                    lucky_percent_x100_min: _item.lucky_percent_x100_min,
                    lucky_percent_x100_max: _item.lucky_percent_x100_max,
                    join_seconds_min: _item.join_seconds_min,
                    join_seconds_max: _item.join_seconds_max,
                    description: _item.description,
                    is_locked: _item.is_locked,
                    atGames: [],
                    tournament_gameset_game_id: _item.bonus_tournament_game_id,
                    tournament_gameset_game_title: _item.gws_gameprovider_game_title
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Турниры", "Изменить бота турнира"]);
                    _this.props.listTournamentGamesAvail.LoadData(_this.props.rootRecord.key);
                });
            }
        }
        else {
            this.setState({
                join_tournament_type_code: 0,
                join_tournament_type_title: "",
                usr_player_id: 0,
                usr_player_login: "",
                lucky_percent_x100_min: 1,
                lucky_percent_x100_max: 100,
                join_seconds_min: 60,
                join_seconds_max: 600,
                description: "",
                is_locked: false,
                atGames: [],
                tournament_gameset_game_id: 0,
                tournament_gameset_game_title: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Турниры", "Добавить бота турнира"]);
                _this.props.listTournamentGamesAvail.LoadData(_this.props.rootRecord.key);
            });
        }
        this.doReSetRules();
    };
    BonusTournamentBotsEditor.prototype.componentWillUnmount = function () {
        this.props.listTournamentGamesAvail.UnSubscribe(this.SID_ATG);
    };
    BonusTournamentBotsEditor.prototype.doReSetRules = function () {
        this.setState({
            usr_player_rules: { isError: false },
            join_tournament_type_rules: { isError: false },
            lucky_percent_x100_min_rules: { isError: false },
            lucky_percent_x100_max_rules: { isError: false },
            join_seconds_min_rules: { isError: false },
            join_seconds_max_rules: { isError: false },
            tournament_gameset_game_rules: { isError: false }
        });
    };
    BonusTournamentBotsEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.join_tournament_type_code <= 0) || (this.state.join_tournament_type_title.length === 0)) {
            this.setState({ join_tournament_type_rules: { isError: true, errorMessage: "Присоединение не выбрано!" } });
            return false;
        }
        if ((this.state.usr_player_id <= 0) || (this.state.usr_player_login.length === 0)) {
            this.setState({ usr_player_rules: { isError: true, errorMessage: "Бот не выбран!" } });
            return false;
        }
        if (this.state.join_seconds_min > this.state.join_seconds_max) {
            this.setState({
                join_seconds_max_rules: { isError: true, errorMessage: "Поле [Максимальный присоединения] меньше минимального!" },
                join_seconds_min_rules: { isError: true, errorMessage: "Поле [Минимальный присоединения] больше максимального!" }
            });
            return false;
        }
        if (this.state.lucky_percent_x100_min > this.state.lucky_percent_x100_max) {
            this.setState({
                lucky_percent_x100_max_rules: { isError: true, errorMessage: "Поле [Максимальная удача] меньше минимальной!" },
                lucky_percent_x100_min_rules: { isError: true, errorMessage: "Поле [Минимальная удача] больше максимальной!" }
            });
            return false;
        }
        if ((this.state.tournament_gameset_game_id <= 0) || (this.state.tournament_gameset_game_title.length === 0)) {
            this.setState({ tournament_gameset_game_rules: { isError: true, errorMessage: "Игра в турнире не выбрана!" } });
            return false;
        }
        return true;
    };
    BonusTournamentBotsEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                usr_player_id: this.state.usr_player_id,
                bonus_tournament_id: this.props.rootRecord.key,
                lucky_percent_x100_min: this.state.lucky_percent_x100_min,
                lucky_percent_x100_max: this.state.lucky_percent_x100_max,
                join_tournament_type_code: this.state.join_tournament_type_code,
                join_seconds_min: this.state.join_seconds_min,
                join_seconds_max: this.state.join_seconds_max,
                description: this.state.description,
                is_locked: this.state.is_locked,
                bonus_tournament_game_id: this.state.tournament_gameset_game_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бот турнира добавлен!");
            });
        }
    };
    BonusTournamentBotsEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                usr_player_id: this.state.usr_player_id,
                lucky_percent_x100_min: this.state.lucky_percent_x100_min,
                lucky_percent_x100_max: this.state.lucky_percent_x100_max,
                join_tournament_type_code: this.state.join_tournament_type_code,
                join_seconds_min: this.state.join_seconds_min,
                join_seconds_max: this.state.join_seconds_max,
                description: this.state.description,
                key: this.props.record.key,
                is_locked: this.state.is_locked
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Бот турнира изменен!");
            });
        }
    };
    BonusTournamentBotsEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTournamentBotsEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить бота турнира";
        }
        else {
            return "Изменить бота турнира";
        }
    };
    BonusTournamentBotsEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusTournamentBotsEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 620 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип присоединения:", placeholder: "Выберите тип присоединения" }, value: { key: this.state.join_tournament_type_code, value: this.state.join_tournament_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        join_tournament_type_code: newVal.key,
                        join_tournament_type_title: newVal.value,
                        join_tournament_type_rules: { isError: false }
                    });
                }, items: this.props.availJoinTypes, required: true, rules: this.state.join_tournament_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игра в турнире:", placeholder: "Выберите игру в турнире" }, value: { key: this.state.tournament_gameset_game_id, value: this.state.tournament_gameset_game_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        tournament_gameset_game_id: newVal.key,
                        tournament_gameset_game_title: newVal.value,
                        tournament_gameset_game_rules: { isError: false }
                    });
                }, items: this.state.atGames, required: true, rules: this.state.tournament_gameset_game_rules, disabled: this.props.record != null }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Минимальный интервал, сек:", placeholder: "Введите минимальный интервал присоединения" }, values: { max: 999999, min: 1, value: this.state.join_seconds_min }, onValueChanged: function (newVal) {
                    _this.setState({
                        join_seconds_min: newVal,
                        join_seconds_min_rules: { isError: false }
                    });
                }, required: true, rules: this.state.join_seconds_min_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Максимальный интервал, сек:", placeholder: "Введите максимальный интервал присоединения" }, values: { max: 999999, min: 1, value: this.state.join_seconds_max }, onValueChanged: function (newVal) {
                    _this.setState({
                        join_seconds_max: newVal,
                        join_seconds_max_rules: { isError: false }
                    });
                }, required: true, rules: this.state.join_seconds_max_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бот:", placeholder: "Выберите бота" }, value: {
                    key: this.state.usr_player_id, value: this.state.usr_player_login
                }, onValueChanged: function (newVal) {
                    _this.setState({
                        usr_player_id: newVal.key,
                        usr_player_login: newVal.value,
                        usr_player_rules: { isError: false }
                    });
                }, items: this.props.availBots, required: true, rules: this.state.usr_player_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Минимальный % удачи:", placeholder: "Введите минимальный % удачи" }, values: { max: 999999, min: 1, value: this.state.lucky_percent_x100_min }, onValueChanged: function (newVal) {
                    _this.setState({
                        lucky_percent_x100_min: newVal,
                        lucky_percent_x100_min_rules: { isError: false }
                    });
                }, required: true, rules: this.state.lucky_percent_x100_min_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Максимальный  % удачи:", placeholder: "Введите максимальный % удачи" }, values: { max: 999999, min: 1, value: this.state.lucky_percent_x100_max }, onValueChanged: function (newVal) {
                    _this.setState({
                        lucky_percent_x100_max: newVal,
                        lucky_percent_x100_max_rules: { isError: false }
                    });
                }, required: true, rules: this.state.lucky_percent_x100_max_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Бот заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.setState({ is_locked: checked }); } }),
            this.getDownButtons()));
    };
    return BonusTournamentBotsEditor;
}(React.Component));
exports.default = BonusTournamentBotsEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/bots/BonusTournamentBotsEditor.tsx
// module id = 2523
// module chunks = 0